import axios from 'axios';
import { Env } from '@/configuration';
import { UserProfile } from './models';

const fetchUserProfile = async (email: string) => {
  const apiUrl = Env.CoreApiOptions.endpointUrl(`users/profile/${email}`);
  const response = await axios.get(apiUrl);
  const result: UserProfile = response && response.data;
  return result;
};

export default {
  fetchUserProfile,
};
